import { CollectionNameEnum, DocumentChangeInterface, ExportFormatEnum, OperationTypeEnum } from "@finway-group/shared/lib/models"
import * as Sentry from "@sentry/react"
import { Dispatch } from "redux"
import i18n from "~Shared/locales/i18n"
import { refetchTable } from "~Shared/store/actions/tables/tableActions"
import { TablesEnum } from "~Shared/store/reducers/tableConfigReducer"
import { isClientErrorCode } from "~Shared/utils/errorHandler.utils"
import FileService from "../file.service"
import NotificationService, { NotificationTypeEnum } from "../notification.service"

const getNotificationLocaleKey = (resource: CollectionNameEnum) => {
    switch (resource) {
        case CollectionNameEnum.COST_CENTER:
            return {
                title: "notification:cost_center.exported_bulk.title",
                message: "notification:cost_center.exported_bulk.message",
            }
        case CollectionNameEnum.EXPENSE:
            return {
                title: "notification:request.exported_bulk.title",
                message: "notification:request.exported_bulk.message",
            }
        case CollectionNameEnum.VENDOR:
            return {
                title: "notification:vendor.exported_bulk.title",
                message: "notification:vendor.exported_bulk.message",
            }
        default:
            return undefined
    }
}

export const subscribeToExportHistoryCallbacks = (dispatch: Dispatch<any>, data: DocumentChangeInterface) => {
    const {
        fullDocument: { operationType, metaData },
    } = data

    try {
        if (operationType === OperationTypeEnum.INSERT || operationType === OperationTypeEnum.UPDATE) {
            dispatch(refetchTable(TablesEnum.EXPORT_HISTORY))
        } else if (operationType === OperationTypeEnum.ASYNC_EXPORT) {
            const { resource, fileUrl, format } = metaData as unknown as { resource: CollectionNameEnum; fileUrl: string; format: ExportFormatEnum }
            if (format === ExportFormatEnum.CHANGE_HISTORY) {
                NotificationService.send(
                    NotificationTypeEnum.SUCCESS,
                    i18n.t("notification:change_history_export.finish.title"),
                    i18n.t("notification:change_history_export.finish.message"),
                    0,
                )
            } else {
                const text = getNotificationLocaleKey(resource)
                if (text) {
                    const { title, message } = text
                    NotificationService.send(NotificationTypeEnum.SUCCESS, i18n.t(title), i18n.t(message), 0)
                }
            }

            if (fileUrl) {
                FileService.downloadFileAsSignedUrl(fileUrl)
            }
        }
    } catch (err) {
        if (isClientErrorCode(err)) {
            return
        }
        Sentry.captureException(`[Export History Socket] Error: ${typeof err === "string" ? err : JSON.stringify(err)}`)
    }
}
